import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Presence Sensor Icon Style 02 - Radio Waves (Material Symbol)
 * A radio signal style icon
 * - isOn = true (occupied): 紅色 + 動畫
 * - isOn = false (unoccupied): 綠色
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:wifi_tethering
 */
export const Style02_Radio: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
  animated = true,
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-red-500' : 'text-green-500';
  const animationClass = isOn && animated ? 'presence-pulse' : '';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${animationClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      wifi_tethering
    </span>
  );
};

export default Style02_Radio;
